<template>
  <div>
    <micro-app
        name='report'
        :url="config.microReportUrl"
        baseroute='/report'
        :data='storeInfo'
        iframe>
    </micro-app>
  </div>
</template>
<script>
import config from '@/config/user.env';
import microApp from '@micro-zoe/micro-app';
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            config,
            storeInfo: {}
        };
    },
    computed: {
        ...mapGetters(['user', 'authority', 'currentTenant', 'appId', 'tenantInfo', 'appList', 'applicationCode', 'supplier', 'btnPermissions'])
    },
    mounted() {
        const {
            user,
            authority,
            currentTenant,
            appId,
            tenantInfo,
            appList,
            applicationCode,
            supplier,
            btnPermissions } = this;
        this.storeInfo = {
            user,
            authority,
            currentTenant,
            appId,
            tenantInfo,
            appList,
            applicationCode,
            supplier,
            btnPermissions
        };
    },
    watch: {
        $route(val) {
            microApp.setData('report', { path: val.path });
        }
    }
};
</script>
